import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import BarChartIcon from '@mui/icons-material/BarChart';
import GroupsIcon from '@mui/icons-material/Groups';
import ScienceIcon from '@mui/icons-material/Science';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import SpeedIcon from '@mui/icons-material/Speed';
import BuildIcon from '@mui/icons-material/Build';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Stack from '@mui/material/Stack';
import Hidden from '@mui/material/Hidden';

import Header from './Header';
import Footer from './Footer';
import RequestDemo from './RequestDemo';
import FreeTrial from './FreeTrial';
import ContactForm from './ContactForm';

import StreamLocatorLogo from './../../StreamLocator_logo.png';
import SMSLiveLogo from './../../smsliveLogo.png';
import StreamLocatorLogoGrey from './../../StreamLocator_logoGrey.png';
import SMSLiveLogoGrey from './../../smsliveLogoGrey.png';
import PBPLogoGrey from './../../pbp_logo_200Grey.png';
import EmergeLogoGrey from './../../emergeLogoGrey.png';
import ConnectionsLogos from './../../ConnectionsLogos.png';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
    },
  },
  button: {
    margin: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(3),
  },
  answer: {
    padding: theme.spacing(2, 0, 0),
  },
  image: {
    flex: 1,
    padding: 2,
    width: 100,
    height: 100,
    resizeMode: 'contain'
  },
  paper: {
    width: 102,
    height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardHeader: {
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
  },
  cardPricing: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginBottom: theme.spacing(1),
  },
}));

const tiers = [
  {
    title: 'Free',
    subheader: '14-day trial',
    price: '$0',
    value: 'Up to 3 seats',
    description: [
    'Data warehouse integration',
    'Github SSO',
    'Help center access',
    'Email support'],
    buttonText: 'Try It Free',
    buttonVariant: 'outlined',
    buttonLink: '/FreeTrial',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#19affd',
      borderColor:'#19affd'
    },
    style: {
      color: 'white',
      backgroundColor:'#19affd',
      borderColor:'#19affd'
    }
  },
  {
    title: 'Business',
    subheader: 'Data orchestration made easy',
    price: '$75',
    value: ' per seat per month',
    description: [
      'Data warehouse integration',
      'Github SSO',
      'Help center access',
      'Email support',
    ],
    buttonText: 'Get Started',
    buttonVariant: 'contained',
    buttonLink: '/FreeTrial',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7'
    },
    style: {
      color: 'white',
      backgroundColor:'#0284c7',
      borderColor:'#0284c7'
    }
  },
  {
    title: 'Enterprise',
    subheader: 'Tailored to your needs',
    price: 'Contact Us',
    value: 'Unlimited seats',
    description: [
      'Data warehouse integration',
      'Custom SSO',
      'Help center access',
      'Phone & email support',
    ],
    buttonText: 'Contact us',
    buttonVariant: 'outlined',
    buttonLink: '/RequestDemo',
    buttonStyle: {
      color: 'white',
      backgroundColor:'#01527c',
      borderColor:'#01527c'
    },
    style: {
      color: 'white',
      backgroundColor:'#01527c',
      borderColor:'#01527c'
    },
  },
];

export default function Pricing() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <Header/>

      <Container maxWidth="lg" component="main" className={classes.heroContent} style={{color:"#37474f"}} >

        <Hidden smDown><Box style={{padding:50}}></Box></Hidden>
        <Hidden mdUp><Box style={{padding:20}}></Box></Hidden>
        <Grid container direction={'row'} alignItems="flex" >
        <Grid
            item
            container
            direction="column"
            alignItems="flex-start"
            justify="center" xs={12} sm={12} md={8} lg={8}
            >
        {/*<Box style={{padding:60}}></Box>*/}
        <Typography component="h1" variant="h3" style={{ padding:5, fontWeight: 'bold', fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textPrimary" >
          Request pricing to fit your unique needs
        </Typography>
        <Hidden smDown>
        <Box style={{padding:20}}></Box>
        <Typography component="h1" variant="h6" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="left" justify="center" color="textSecondary" >
          Your business needs don't fit in a box so why should your data solutions. Get easily accessible and manageable data that fits your company's unique requirements.
          Base13 Labs sets up your data stack, gets you the insights you need, and helps you take control of your data.
        </Typography>
        <Box style={{padding:10}}></Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <JoinFullIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Join 100s of Sources</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <AllInclusiveIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', paddingLeft:10}} align="center" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3 }} display='inline' >Scales with your growth</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <BuildIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Customizable to your needs</Box>
        </Typography>
        </Box>
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <SpeedIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="h4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Data at the speed of your decision making</Box>
        </Typography>
        </Box>
        {/*<Box style={{padding:10}}></Box>*/}
        <Box
        display="flex"
        alignItems="left"
        justifyContent="left"
        style={{padding:0}}
        >
        <ScienceIcon style={{color:'#0284c7', width:40, height:40}} fontsize="small"/>
        <Typography variant="h6" style={{ fontFamily: 'Arial', padding:5 }} align="center" color="textSecondary" component="p4">
         <Box sx={{ fontWeight: 'bold', paddingRight:3}} display='inline' >Build in predictive capabilities</Box>
        </Typography>
        </Box>
        </Hidden>
        <Box style={{padding:20}}></Box>
        {/*<Box
          display="flex"
          alignItems="left"
          justifyContent="left"
          style={{padding:40}}
          >*/}
          {/*<Box className={classes.button} >
            <Button size="large" href='/LearnMore' variant="outlined" style={{color: "white", backgroundColor:"#0284c7", borderColor:"#0284c7", fontSize: '20px', maxWidth: '250px', maxHeight: '50px', minWidth: '100px', minHeight: '20px', textTransform: 'none'}} >Learn More</Button>
          </Box>*/}
          {/*<Box style={{padding:10}}></Box>*/}
          {/*<Box className={classes.button}>
            <Button size="large" href='https://www.flosql.com/?utm_source=referral&utm_medium=website&utm_campaign=base13header' variant="outlined" style={{color: "#0284c7", borderColor:"#0284c7", textTransform: 'none'}} startIcon={<img src={FloSQLIcon} style={{ maxWidth:25 }} />} target="_blank">Go to FloSQL</Button>
          </Box>*/}
          {/*</Box>*/}
          <Hidden mdUp>
            <Grid container alignItems="flex-end" >
            <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
            <Typography component="h5" variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="center" justify="center" color="textSecondary" >
              Businesses with an effective data strategy use Base13 Labs
            </Typography>

            <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2, md: 4 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:20}}
            >
              <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoGrey}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoGrey}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoGrey}/>
              <img className={classes.dwdblogoPadding} />
              <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoGrey}/>

            </Stack>
            </Grid>
            </Grid>
            </Hidden>

        </Grid>
        {/*<Box style={{padding:50}}></Box>*/}
        <Grid item
            container
            alignItems="flex"
            justify="center"
            xs={12} sm={12} md={4} lg={4}
            // paddingRight={25}
            >
            <Paper elevation={3}>
        <Box
                display="block"
                alignItems="center"
                justifyContent="center"
                style={{padding:30}}
              >
                <ContactForm />
              </Box>
              </Paper >
        </Grid>
        </Grid>

       <Box style={{padding:50}}></Box>
       <Hidden smDown>
        <Grid container alignItems="flex-end" >
        <Grid xs={12} sm={12} md={12} lg={12} alignItems="flex-end">
        <Typography component="h5" variant="h5" style={{ fontStyle: 'bolded', fontFamily: 'Arial'}} align="center" justify="center" color="textSecondary" >
          Businesses with an effective data strategy use Base13 Labs
        </Typography>

        <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 1, sm: 2, md: 4 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:20}}
        >
          <img className={classes.streamLocatorLogo} style={{ maxWidth: 150 }} src={StreamLocatorLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 175 }} src={PBPLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={EmergeLogoGrey}/>
          <img className={classes.dwdblogoPadding} />
          <img className={classes.smsLiveLogo} style={{ maxWidth: 125 }} src={SMSLiveLogoGrey}/>

        </Stack>
        </Grid>
        </Grid>




        <Box style={{padding:50}}></Box>
        </Hidden>


      {/*<Container maxWidth="sm" component="main" className={classes.heroContent}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:10}}
        >
        </Box>
        <Typography component="h1" style={{padding:30}} variant="h2" align="center" color="textPrimary" gutterBottom>
          Pricing
        </Typography>
        <Typography variant="h5" align="center" color="textSecondary" component="p">
          Building on top of your warehouse is finally easy and accessible for your entire data team.
        </Typography>
      </Container>


      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {tiers.map((tier) => (
            // Enterprise card is full width at sm breakpoint
            <Grid item key={tier.title} xs={12} sm={tier.title === 'Business' ? 14 : 6} md={4}>
              <Card>
                <CardHeader
                  title={tier.title}
                  subheader={tier.subheader}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{ align: 'center', color: "white" }}
                  action={tier.title === 'Pro' ? <StarIcon /> : null}
                  className={classes.cardHeader}
                  style={tier.style}
                />
                <CardContent>
                  <div className={classes.cardPricing}>
                    <Typography component="h4" variant="h4" color="textPrimary">
                      {tier.price}
                    </Typography>
                  </div>
                  <div className={classes.cardPricing}>
                    <Typography variant="h6" color="textSecondary">
                      {tier.value}
                    </Typography>
                  </div>
                  <ul>
                    {tier.description.map((line) => (
                      <Typography component="li" variant="subtitle1" align="center" key={line}>
                        {line}
                      </Typography>
                    ))}
                  </ul>
                </CardContent>
                <CardActions>
                  <Button fullWidth href={tier.buttonLink} variant={tier.buttonVariant} style={tier.buttonStyle} color="primary">
                    {tier.buttonText}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}

        </Grid>
      </Container>*/}
      </Container>


      {/*<Container maxWidth="sm" component="main" className={classes.heroContent}>
      <Grid container alignItems="flex-end" >
      <Grid xs={12} sm={12} md={12} lg={12} >
      <Box style={{padding:20}}>

        <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h5" align="left" color="textPrimary" component="p">
          Why choose FloSQL?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          FloSQL was built on a foundation of providing the best data engineering tools with uncomprimising quality. With our decades of experience working with data we have been able to ensure our technology has been built for high growth high impact environments. At Base13 Labs we are committed to our customers and their success above all else. For more about us please visit <Link href='/About'>here</Link>.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h5" align="left" color="textPrimary" component="p">
          What is data orchestration?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          Data orchestration is the process of taking siloed data from multiple data storage locations, combining and organizing it, and making it available for data analysis tools.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        <Typography variant="h5" align="left" color="textPrimary" component="p">
          Is there a free trial?
        </Typography>
        <Typography variant="body1" align="left" color="textSecondary" component="p" className={classes.answer}>
          Yes, there is a 14-day free trial. At the end of the trial tasks will no longer run. You will still have access to your account as well as information you have inputted including all queries and templates for another 14 days until your data is archived. You can upgrade to an account at any time and your 14-day free trial will still be honored for its duration.
        </Typography>
        <Divider variant="middle" className={classes.divider}/>
        </Box>
        </Grid>
        </Grid>
      </Container>*/}

      <Footer/>
    </React.Fragment>
  );
}
